export const filterLabels = ['Veličina', 'Големина', 'Size'];